export const DUMMY_MERMAID_CHART_EXAMPLES = {
  flowchart: {
    title: "Loan Application Flowchart",
    diagram: `
flowchart TD
    A[Access Appraisal Task List] --> B[Open Appraisal Report]
    B --> Req_Input_Appraisal[Input, AppraisalReport PDF]
    B --> Req_System_Box[System, Box for Document Storage]
    B --> Req_System_SF[System, Salesforce for Task Tracking]
    B --> C{Determine Appraisal Form Type}
    
    C -->|Form 1004 URAR| D[Review 1004 URAR<br/>As Is and Subject To values<br/>3 to 6 sales comps<br/>Cost and Income reconciliation]
    C -->|Form 1025 Income| E[Review 1025 Income<br/>As Is and Subject To values<br/>Sales and Rent comps<br/>NOI, GRM, Cap Rate]
    C -->|Form 1007 Rent| F[Review 1007 Rent<br/>Market Rent As Is and After Renovation<br/>Attach rehab estimate if applicable]
    C -->|Form 1073 Condo| G[Review 1073 Condo<br/>As Is and Subject To values<br/>HOA fees, Project Size, Owner Occupancy%]
    C -->|Form 1004D Update| H[Review 1004D Update<br/>Completion and Update values<br/>Verify prior budget and completion]
    
    D --> I[Confirm Property Address matches file]
    E --> I
    F --> I
    G --> I
    H --> I
    
    I --> Req_Acceptance_Address[Acceptance, Address matches file record]
    I --> J[Confirm Borrower Name matches entity on file]
    J --> Req_Acceptance_Borrower[Acceptance, Borrower name matches legal entity]
    J --> K[Verify Occupant Status, Owner Tenant Vacant]
    K --> Req_Occupancy_Evidence[Acceptance, Occupancy evidence present if required]
    K --> L[Confirm Assignment Type and Property Rights<br/>Must be Fee Simple]
    L --> Req_PropertyRights[Acceptance, Property rights documented as Fee Simple]
    L --> M[If Purchase, confirm Contract Price and Contract Date included]
    M --> Req_PurchaseDocs[Input, Purchase Contract and Contract Date]
    M --> N[Verify Location is Urban or Suburban, not Rural]
    N --> Req_Location_Risk[Acceptance, Location classified, Rural flag triggers escalation]
    N --> O[Read Neighborhood Description for desirability and amenities]
    O --> Req_Neighborhood[Acceptance, Neighborhood description evaluated]
    O --> P[Check Zoning Compliance, not marked Illegal]
    P --> Req_Zoning[Acceptance, Zoning compliance documented, Illegal flag triggers exceptions]
    P --> Q[Confirm FEMA Flood Zone status, request Flood Insurance if in zone]
    Q --> Req_Flood[Acceptance, FEMA flood zone noted, Flood Insurance required if applicable]
    Q --> R{Flag Adverse Site Conditions?}
    
    R -->|Yes| RY[Flag Adverse Site Conditions, note details]
    R -->|No| RN[No Adverse Site Conditions noted]
    RY --> S[Verify Number of Units, Room Count, GLA GBA, Site size]
    RN --> S
    
    S --> Req_PropertySpecs[Acceptance, Units rooms area and site size validated]
    S --> T[Confirm Fuel Type, if Oil then verify above ground tank photo or order Environmental]
    T --> Req_Enviro_Trigger[Requirement, Order environmental if oil fuel or tank photo missing]
    T --> U[Assess Condition Rating, ensure C1 to C4 for 30yr DSCR loans]
    U --> Req_Condition_Criteria[Acceptance, Condition rating within product limits]
    U --> V[Note Physical Deficiencies, require rehab budget or pre closing repairs as per product]
    V --> Req_Deficiency_Action[Requirement, Rehab budget or pre closing repairs documented]
    V --> W[Scope of Work present and legible for rehab loans, attach Rehab Budget SOW]
    W --> Req_SOW[Acceptance, SOW and Rehab Budget attached and legible]
    W --> X[Review Comparable Selection<br/>Proximity, date, site, design, age, condition, room GLA units]
    X --> Req_Comp_Selection[Acceptance, Comps meet proximity and similarity criteria]
    X --> Y[Validate Appraiser Info<br/>Report date, license active, not Trainee]
    Y --> Req_Appraiser[Acceptance, Appraiser license and status verified]
    Y --> Z[Cross check Subject and Comps on maps Zillow, validate photos and addresses]
    Z --> Req_Photo_Address[Acceptance, Photos and addresses validated against maps]
    Z --> AA[Prepare Additional Notes, flag issues and LTV risk]
    AA --> Req_Risk_Flagging[Requirement, Issues logged, LTV risk calculated and noted]
    AA --> AB[Send Documents to AMC as needed<br/>Condo Questionnaire, Contract, Rehab Budget, Plans, Leases]
    AB --> Req_Docs_To_AMC[Process, Documents packaged and transmitted to AMC]
    AB --> AC{Any Issues Requiring Revision?}
    
    AC -->|No| AD[Approve Appraisal for File]
    AC -->|Yes| AE[Request Revision from AMC, or order Environmental or additional docs, or escalate to Underwriting]
    AD --> AF[Complete Appraisal Task]
    AE --> AF
    AF --> Req_SLA_Complete[Measurement, Task completion timestamp and reviewer recorded]
    
    Req_System_SF --> Req_SLA_Complete
    Req_Input_Appraisal --> Req_Photo_Address
    Req_Docs_To_AMC --> Req_SLA_Complete
    Req_Risk_Flagging --> Req_SLA_Complete
    
    style Req_Input_Appraisal fill:#F9F,stroke:#333,stroke-width:1px
    style Req_System_Box fill:#F9F,stroke:#333,stroke-width:1px
    style Req_System_SF fill:#F9F,stroke:#333,stroke-width:1px
    style Req_SLA_Complete fill:#CFC,stroke:#333,stroke-width:1px
`,
  },
  sequence: {
    title: "Loan Processing Sequence",
    diagram: `
        sequenceDiagram
          participant LO as Loan Officer
          participant System as LOS System
          participant UW as Underwriter
          participant Borrower as Borrower
          
          LO->>System: Create Loan Application
          System->>Borrower: Send Application Link
          Borrower->>System: Submit Application
          System->>LO: Notify Completion
          LO->>System: Submit to Underwriting
          System->>UW: Assign Loan
          UW->>System: Request Documents
          System->>Borrower: Document Request
          Borrower->>System: Upload Documents
          System->>UW: Notify Upload
          UW->>System: Approve Loan
          System->>LO: Loan Approved
      `,
  },
  gantt: {
    title: "Loan Timeline",
    diagram: `
        gantt
          title Loan Processing Timeline
          dateFormat YYYY-MM-DD
          section Application
            Initial Application    :a1, 2024-01-01, 3d
            Credit Check          :a2, after a1, 2d
            Document Collection   :a3, after a2, 5d
          section Underwriting
            Initial Review        :u1, after a3, 3d
            Appraisal            :u2, after u1, 7d
            Final Approval       :u3, after u2, 2d
          section Closing
            Closing Prep         :c1, after u3, 3d
            Final Close          :c2, after c1, 1d
      `,
  },
  pie: {
    title: "Loan Status Distribution",
    diagram: `
        pie title Loans by Status
          "In Progress" : 45
          "Underwriting" : 30
          "Approved" : 15
          "Closed" : 60
          "Denied" : 10
      `,
  },
  state: {
    title: "Loan State Diagram",
    diagram: `
        stateDiagram-v2
          [*] --> Draft
          Draft --> Submitted: Submit Application
          Submitted --> InReview: Assign to LO
          InReview --> Underwriting: Send to Underwriting
          InReview --> Draft: Return for Edits
          Underwriting --> Approved: Approve
          Underwriting --> Denied: Deny
          Underwriting --> InReview: Request More Info
          Approved --> Closed: Close Loan
          Closed --> [*]
          Denied --> [*]
      `,
  },
  erDiagram: {
    title: "Loan Database Schema",
    diagram: `
        erDiagram
          LOAN ||--o{ BORROWER : has
          LOAN ||--o{ PROPERTY : secures
          LOAN ||--|| LOAN_OFFICER : "assigned to"
          LOAN ||--o{ DOCUMENT : contains
          BORROWER ||--o{ DOCUMENT : uploads
          
          LOAN {
            int id PK
            string loan_number
            decimal amount
            string status
            date created_at
          }
          
          BORROWER {
            int id PK
            string name
            string email
            string ssn
            int loan_id FK
          }
          
          PROPERTY {
            int id PK
            string address
            decimal value
            int loan_id FK
          }
          
          LOAN_OFFICER {
            int id PK
            string name
            string email
          }
          
          DOCUMENT {
            int id PK
            string name
            string type
            date uploaded_at
          }
      `,
  },
  class: {
    title: "LOS Component Architecture",
    diagram: `
        classDiagram
          class LoanPipelineScreen {
            +loans: Array
            +filters: Object
            +loadLoans()
            +applyFilters()
            +render()
          }
          
          class LoanDrilldownScreen {
            +loan: Object
            +tabs: Array
            +loadLoanDetails()
            +updateLoan()
          }
          
          class AGGridTable {
            +columnDefs: Array
            +rowData: Array
            +onCellClick()
            +onFilterChanged()
          }
          
          class ReduxStore {
            +loans: Object
            +user: Object
            +dispatch()
          }
          
          LoanPipelineScreen --> AGGridTable
          LoanDrilldownScreen --> ReduxStore
          LoanPipelineScreen --> ReduxStore
          AGGridTable --> ReduxStore
      `,
  },
};
